<div class="card">

  <div class="border-0">
    <button style="float:right" class="add-item-btn" title="Export" (click)="export()">
      <i class='fas fileicons'>&#xf381;</i>
      Export
    </button>
  </div>
  <div class="table-responsive" data-toggle="list">
    <table class="table mb-3" id="attendance">
      <thead class="thead-light">
        <tr>
          <th colspan="5">
            <h2 class="mb-0">Students' List </h2>
          </th>
        </tr>
        <tr>
          <div class="fieldset mx-0 my-3" *ngIf="allowBatches">
            <label class="legend">Batch</label>
            <select class="text-field" (change)="setBatchId($event.target.value)" >
              <option *ngFor="let batch of batchFilterActions" [value]="batch.params.id">{{batch.displaytext}}</option>
            </select>
          </div>
        </tr>
        <tr>
          <th scope="col" class="">S No.</th>
          <th scope="col">Name</th>
          <th scope="col">Email</th>
          <th scope="col">Completed Lessons</th>
          <th scope="col">Percentage Score</th>
          <th scope="col">Attendance Percentage</th>
        </tr>
      </thead>
      <tbody class="list">
        <tr *ngFor="let student of students | paginate: {  itemsPerPage: itemsPerPage , currentPage: p, totalItems: totalItems}; let i = index"
          [ngClass]="{'bg-customgreen': student.lessonstats.passed, 'bg-customorange': !student.lessonstats.passed && student.lessonstats.noofcompletedcourses != '0'}" class="mb-10">
          <td class="sno">
            {{((p - 1) * itemsPerPage) + (i + 1)}}
          </td>
          <td>{{student.user.name}}</td>
          <td class="email">
            {{student.user.email}}
          </td>
          <td>{{student.lessonstats.noofcompletedcourses}} of {{student.lessonstats.totalcourses}}</td>
          <td>{{student.lessonstats.score}}</td>
          <td>{{student.lessonstats.attendancePercentage}}</td>
        </tr>
      </tbody>

    </table>
    <pagination-controls (pageChange)="getPage(p = $event)"></pagination-controls>
  </div>

</div>
